import './ccf-person-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfPersonIconProps extends SvgIconProps {}
/**
 * component used to display person icon in customer history card
 * @param props - CcfPersonIconProps
 * @example - <CcfPersonIcon />
 * @returns SVG of person icon in customer history card
 */
export function CcfPersonIcon(props: CcfPersonIconProps) {
  return (
    <SvgIcon viewBox="0 0 14.549 20" {...props}>
      <g transform="translate(-0.933 0.313)"><rect className="a" width="9.215" height="9.217" rx="4.607" transform="translate(3.843 -0.313)"/><path className="a" d="M6.835-.439A7.266,7.266,0,0,1,14.11,6.837c0,4.026-14.549,4.026-14.549,0A7.266,7.266,0,0,1,6.835-.439Z" transform="translate(1.372 9.83)"/></g>
    </SvgIcon>
  );
}

export default CcfPersonIcon;
